<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="font-weight-600 text-dark mb-0">
                <i class="fad fa-receipt text-primary fa-fw mr-3"/>Stvrzenky
            </h5>
            <div class="buttons">
                <BButton
                    v-if="selectedReceipts.length > 0"
                    variant="success"
                    size="sm"
                    :disabled="isHandingOver"
                    @click="handOverSelected"
                >
                    <i class="fad fa-hand-holding-dollar mr-2"/>
                    Předat vybrané ({{ selectedReceipts.length }})
                </BButton>
            </div>
        </div>

        <div v-if="isLoading === false && receipts.length > 0">
            <table class="table table-scroll-sm table-sm table-borderless bg-white border-radius-sm">
                <thead>
                <tr class="border-bottom">
                    <th class="align-middle" style="width: 40px;">
                        <BFormCheckbox
                            v-model="selectAll"
                            @change="toggleSelectAll"
                            :indeterminate="isIndeterminate"
                            :disabled="notHandedOverReceipts.length === 0"
                        />
                    </th>
                    <th class="align-middle">Číslo stvrzenky</th>
                    <th class="align-middle">Částka</th>
                    <th class="align-middle">Číslo faktury</th>
                    <th class="align-middle">Přijato od</th>
                    <th class="align-middle">Vystaveno</th>
                    <th class="align-middle">Stav</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="receipt in receipts" :key="receipt.id" class="border-bottom">
                    <td class="align-middle">
                        <BFormCheckbox
                            v-if="!receipt.handedOver"
                            v-model="selectedReceipts"
                            :value="receipt.id"
                        />
                        <i v-else class="fad fa-check text-success"/>
                    </td>
                    <td class="align-middle font-weight-600">
                        {{ receipt.receiptNumber }}
                    </td>
                    <td class="align-middle">
                        {{ receipt.amount | moneyFormat("CZK_LONG") }}
                    </td>
                    <td class="align-middle">
                        {{ receipt.invoiceNumber || '-' }}
                    </td>
                    <td class="align-middle">
                        {{ receipt.receivedByName }}
                    </td>
                    <td class="align-middle">
                        {{ receipt.issuedAt | dateTimeFormat }}
                    </td>
                    <td class="align-middle">
                        <span v-if="receipt.handedOver" class="badge badge-success">
                            <i class="fad fa-check mr-1"/>Předáno {{ receipt.handedOverAt | dateTimeFormat }}
                        </span>
                        <span v-else class="badge badge-warning">
                            <i class="fad fa-clock mr-1"/>K předání
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>

            <div v-if="notHandedOverReceipts.length > 0" class="mt-3 p-3 bg-light border-radius-sm">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <strong>Celkem k předání:</strong>
                        {{ totalNotHandedOver | moneyFormat("CZK_LONG") }}
                    </div>
                    <BButton
                        variant="primary"
                        :disabled="isHandingOver || notHandedOverReceipts.length === 0"
                        @click="handOverAll"
                    >
                        <i class="fad fa-hand-holding-dollar mr-2"/>
                        Předat vše ({{ notHandedOverReceipts.length }})
                    </BButton>
                </div>
            </div>
        </div>

        <TableLoading v-else-if="isLoading === true"/>

        <TableWithoutRecords v-else>
            Nemáte žádné stvrzenky.
        </TableWithoutRecords>
    </div>
</template>

<script>
import ReceiptService from "../../../../NewModel/Receipt/ReceiptService"
import TableLoading from "@/Module/Common/UI/Table/TableLoading.vue"
import TableWithoutRecords from "@/Module/Common/UI/Table/TableWithoutRecords.vue"

export default {

    components: {
        TableLoading,
        TableWithoutRecords,
    },

    data() {
        return {
            isLoading: false,
            isHandingOver: false,
            receipts: [],
            selectedReceipts: [],
            selectAll: false,
        }
    },

    computed: {
        notHandedOverReceipts() {
            return this.receipts.filter(r => !r.handedOver)
        },
        totalNotHandedOver() {
            return this.notHandedOverReceipts.reduce((sum, r) => sum + r.amount, 0)
        },
        isIndeterminate() {
            return this.selectedReceipts.length > 0 &&
                this.selectedReceipts.length < this.notHandedOverReceipts.length
        },
    },

    watch: {
        selectedReceipts(newVal) {
            this.selectAll = newVal.length === this.notHandedOverReceipts.length &&
                this.notHandedOverReceipts.length > 0
        },
    },

    mounted() {
        this.loadReceipts()
    },

    methods: {

        loadReceipts() {
            this.isLoading = true
            this.receipts = []

            ReceiptService.findReceipts()
                .then((response) => {
                    this.receipts = response.data
                })
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        toggleSelectAll(checked) {
            if (checked) {
                this.selectedReceipts = this.notHandedOverReceipts.map(r => r.id)
            } else {
                this.selectedReceipts = []
            }
        },

        handOverSelected() {
            if (this.selectedReceipts.length === 0) {
                return
            }

            this.handOverReceipts(this.selectedReceipts)
        },

        handOverAll() {
            const ids = this.notHandedOverReceipts.map(r => r.id)
            this.handOverReceipts(ids)
        },

        handOverReceipts(receiptIds) {
            this.isHandingOver = true

            ReceiptService.handOverReceipts(receiptIds)
                .then(() => {
                    this.successMessage('Stvrzenky byly úspěšně předány. Dispečer obdržel email s informací.')
                    this.selectedReceipts = []
                    this.loadReceipts()
                })
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
                .finally(() => {
                    this.isHandingOver = false
                })
        },

    },

}
</script>
